import { render, staticRenderFns } from "./BreakpointEditor.vue?vue&type=template&id=e1aa9faa&scoped=true"
import script from "./BreakpointEditor.vue?vue&type=script&lang=js"
export * from "./BreakpointEditor.vue?vue&type=script&lang=js"
import style0 from "./BreakpointEditor.vue?vue&type=style&index=0&id=e1aa9faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aa9faa",
  null
  
)

export default component.exports